import { render, staticRenderFns } from "./ChainSelection.vue?vue&type=template&id=148db73e&scoped=true&"
import script from "./ChainSelection.vue?vue&type=script&lang=js&"
export * from "./ChainSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148db73e",
  null
  
)

export default component.exports